import { Children, useEffect, useState } from 'react'
import {
  Create,
  SimpleForm,
  FormDataConsumer,
  required,
  SelectInput,
  ReferenceInput,
  useGetOne,
  useNotify,
  TextInput,
  NumberField,
  TextField,
  AutocompleteInput,
  useRefresh,
  useDataProvider,
  DateInput,
  List,
  Datagrid,
  Filter,
  SearchInput,
  useRecordContext,
  useTranslate,
  BooleanInput,
  useListContext,
  Toolbar,
  RecordContextProvider,
  DatagridBody,
  SaveButton,
  useSaveContext,
} from 'react-admin'
import MuiTextField from '@mui/material/TextField'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'

import { DynamicInputComponentBO } from './tickets_common'
import { CreateToolbar, draft_color, NoPagination } from './utils'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Alert from './components/alert'
import Front from '@frontapp/plugin-sdk'
import {
  Box,
  Button as Button,
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
  useMediaQuery,
} from '@material-ui/core'
import UpsertFileButton from './components/file_upload'
import FileWithContext from './models/file_with_context'
import { useLocation } from 'react-router-dom'
// import { CoownerEditDialog } from './tickets_generic'
import { makeStyles } from '@material-ui/core/styles'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import Api from './Apis/api.service'
import { backofficeRequest } from './axios'
import { Autocomplete } from '@mui/material'
import Relation from './models/relation'
import BindFile from './exceptions/file_with_context/bind_file'
import { useFormContext, useFormState } from 'react-hook-form'
import { FrontPluginHome } from './front/plugin/FrontPluginHome'
import { FrontPluginCTA } from './front/plugin/components/CTA'
import { Alert as MuiAlert } from '@mui/material'

const useStyles = makeStyles({
  dynamicInputComponentRow: {
    marginBottom: '1.7rem',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 6,
  },
  rowInfos: {
    marginLeft: 10,
  },
  mainList: {
    '&>.RaList-main .RaList-content .RaBulkActionsToolbar-toolbar .RaBulkActionsToolbar-topToolbar':
      {
        background: 'transparent',
      },
  },
})

const CONDO_SLUG_CUSTOM_FIELD = 'slug-copro'

const ListRelatedTickets = (props) => {
  if (props.conversations.length !== 1) {
    return null
  }
  const conv_id = props.conversations[0]['id']
  const filter = { conv_id: conv_id }

  return (
    <List
      resource="tickets"
      basePath="/"
      title=" "
      actions={null}
      bulkActionButtons={false}
      sort={{ field: 'created', order: 'DESC' }}
      exporter={false}
      filter={filter}
      pagination={<NoPagination />}
    >
      <Datagrid bulkActionButtons={false}>
        <NumberField source="id" label="N° Ticket" />
        <TextField source="libelle" label="Libelle" />
      </Datagrid>
    </List>
  )
}

const TicketFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" placeholder="Rechercher" alwaysOn />
  </Filter>
)

const TicketBulkActionButtons = ({ conversations, refresh }) => {
  const { data, selectedIds } = useListContext()
  const dataProvider = useDataProvider()
  const notify = useNotify()

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  const func = () => {
    const records = data.filter((item) => selectedIds.includes(item.id))
    records.map((record) => {
      const conversations_not_already_attached = conversations.filter((c) => {
        return record.conversations.indexOf(c.id) === -1
      })
      console.log(
        'conversations_not_already_attached',
        conversations_not_already_attached
      )
      if (conversations_not_already_attached.length > 0) {
        dataProvider
          .update('tickets', {
            id: record.id,
            data: { ...record, conversations: conversations },
          })
          .then(() => {
            goToTop()
            notify('Conversation rattachée avec succès !')
            refresh()
          })
          .catch((error) => {
            alert(`${error.message}`, 'warning')
          })
      } else {
        console.log('conversation not attached')
      }
    })
  }

  return (
    <Toolbar
      sx={{
        padding: '8px',
        alignItems: 'center',
        background: { xs: '#f5f5f5', md: 'transparent' },
      }}
    >
      <Button
        variant="contained"
        color="primary"
        label="Rattacher"
        onClick={func}
        size="small"
        disableElevation
      >
        Rattacher
      </Button>
    </Toolbar>
  )
}

const ListTickets = (props) => {
  const { conversations, refresh } = props
  const classes = useStyles()
  return (
    <List
      resource="tickets"
      basePath="/"
      title=" "
      actions={null}
      sort={{ field: 'created', order: 'DESC' }}
      exporter={false}
      filters={<TicketFilter />}
      sx={{
        overflow: 'auto',
      }}
      className={classes.mainList}
    >
      <MyDatagrid
        bulkActionButtons={
          <TicketBulkActionButtons
            conversations={conversations}
            refresh={refresh}
          />
        }
      >
        <NumberField source="id" label="N°" />
        <TextField source="code" label="Copro" />
        <TextField source="libelle" label="Libelle" />
      </MyDatagrid>
    </List>
  )
}

const FrontPluginTicketCreate = (props) => {
  const dataProvider = useDataProvider()
  const [processid, setProcessid] = useState(-1)
  const [process, setProcess] = useState(undefined)
  const [is_draft, setDraft] = useState(false)
  const [justcreated, setJustcreated] = useState(false)
  const [id, setId] = useState(-1)
  const notify = useNotify()
  const location = useLocation()
  const [coowner_id, setCoownerId] = useState()
  const [disable_fields, setDisableFields] = useState([])
  const translate = useTranslate()
  const [filesToBind, setFilesToBind] = useState([])
  const [coproInternalId, setCoproInternalId] = useState(null)

  const classes = useStyles()

  const onFailure = (error) => {
    notify(`${error.message}`)
  }
  const onSuccess = (data) => {
    const { file_with_context, id } = data

    const relation = new Relation({
      linkable_type: 'tickets',
      linkable_id: id,
    })
    if (file_with_context && file_with_context.length > 0) {
      dataProvider
        .updateMany('file_with_context', {
          ids: file_with_context.map((f) => f.id),
          data: relation.toJSON(),
        })
        .then(() => {
          notify('Le ticket HelloApp a été créé', { type: 'success' })
        })
        .catch((e) => {
          throw new BindFile(
            'tickets',
            id,
            file_with_context.map((f) => f.id).join(', ')
          )
        })
    } else {
      notify('Le ticket HelloApp a été créé', { type: 'success' })
    }

    setId(data.id)
    setJustcreated(true)
  }
  const { data, loading, error } = useGetOne(
    'process',
    { id: processid },
    {
      enabled: processid ? true : false,
    }
  )
  useEffect(() => {
    if (data) {
      setProcess(data)
    }
  }, [data, loading])
  const previous = () => {
    setId(undefined)
    setJustcreated(false)
  }

  //NOTE: we need ticket_fields info for dataprovider, so that it can convert image fields to base64
  //We put ..params first because we don't want it to override ticket_fields (sometimes, url ends up containing ticket_fields=[Object Object])
  const init_values = {
    ticket_fields: process ? process.ticket_fields : [],
    conversations: props.conversations,
  }

  //NOTE: We use a Show component inside the FormDataConsumer to fetch the process object
  //and the fields key.
  //By luck, input fields inside the Show still have their values taken into
  //account by the outer Create component

  //NOTE2: for is_draft, initially we tried adding a save draft button in toolbar but
  //I could not make it work. I passed setDraft to the Toolbar component and added a new button
  //in toolbar with a specific handleClick that set is_draft to true before calling props.handlesubmit
  //but it did not work. handleSubmit always took the previous is_draft value, some kind of "one render cycle late" or sth alike
  //Alternative was to use a standalone SimpleForm component without Toolbar and make custom Buttons inside SimpleForm
  //but even then there were issues: handling redirect was a pain, and moreover Buttons inside SimpleForm
  // had a {} props.record even when the form was filled. Trying to use formData to update a record state variable caused an infinite loop.
  //So in the end I decided to go for the simple option: just use a booleanInput, and one, regular, save button in a toolbar

  return (
    <div style={{ padding: '16px 0' }}>
      <Grid container spacing={2} justify="center">
        <Grid item xs={11} md={6}>
          <Alert>
            <Typography>
              Attention : certaines informations saisies ici peuvent être
              visibles par les copropriétaires et/ou prestataires.
            </Typography>
          </Alert>
        </Grid>
      </Grid>
      <Grid container spacing={2} justify="center">
        <Grid item xs={11} md={6}>
          <Create
            onFailure={onFailure}
            mutationOptions={{ onSuccess }}
            mutationMode="pessimistic"
            {...props}
          >
            <SimpleForm
              redirect={false}
              defaultValues={init_values}
              variant="outlined"
              toolbar={false}
              style={{ backgroundColor: 'white' }}
            >
              <ReferenceInput
                source="process_id"
                reference="process_published"
                validate={[required()]}
                defaultValue={
                  location.state
                    ? location.state.process_id
                      ? location.state.process_id
                      : undefined
                    : undefined
                }
              >
                <SelectInput
                  onChange={(e) => {
                    setProcessid(e.target.value)
                  }}
                  label="Process"
                  fullWidth
                  optionText="name"
                  required
                />
              </ReferenceInput>
              <ReferenceInput
                fullWidth
                label="Code Copro"
                source="copro_id"
                reference="copros_monday"
              >
                <AutocompleteInput
                  fullWidth
                  validate={[required()]}
                  optionText="code"
                  matchSuggestion={() => true}
                  onChange={(e) => {
                    Api.copros.getByMondayId(e).then((value) => {
                      setCoproInternalId(value.data.copro_internal_id)
                    })
                  }}
                />
              </ReferenceInput>
              <TextInput
                fullWidth
                source="libelle"
                label="Libellé"
                validate={[required()]}
              />

              <FormDataConsumer>
                {({ formData, ...rest }) => {
                  if (!formData.process_id) return null
                  window.context['context-process'] = formData.process_id
                  //NOTE: the process fetch is async so sometimes ticket deadline
                  //won't be init right away, it will take another field edit for the update to happen
                  if (formData.deadline == undefined && process !== undefined) {
                    const d = new Date()
                    formData.deadline = d.addDays(process.deadline)
                  }
                  return null
                }}
              </FormDataConsumer>

              <FormDataConsumer>
                {({ formData, ...rest }) => {
                  if (!formData.process_id) {
                    return null
                  }
                  if (!formData.copro_id) {
                    return null
                  }
                  return (
                    <DynamicInputComponentBO
                      disabledFields={disable_fields}
                      formData={formData}
                      record={process}
                      variant="outlined"
                    >
                      {parseInt(formData[`coowner`]) > 0 && (
                        <Button
                          insertAt={2}
                          fullWidth
                          variant="outlined"
                          color="primary"
                          className={classes.dynamicInputComponentRow}
                          onClick={() => {
                            setCoownerId(parseInt(formData[`coowner`]))
                          }}
                        >
                          {translate(
                            'resources.tickets.fields.verify_coowner_info'
                          )}
                        </Button>
                      )}
                    </DynamicInputComponentBO>
                  )
                }}
              </FormDataConsumer>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'row',
                  width: '100%',
                }}
              >
                <FormDataConsumer>
                  {() => {
                    const { isValid } = useFormState()
                    const form = useFormContext()
                    const saveContext = useSaveContext()

                    const onClick = form.handleSubmit((values) => {
                      saveContext.save(values)
                      window.location.reload()
                    })
                    return (
                      <SaveButton
                        onClick={onClick}
                        color="primary"
                        variant="contained"
                        disableElevation
                        type="submit"
                        disabled={!isValid}
                      >
                        Enregistrer
                      </SaveButton>
                    )
                  }}
                </FormDataConsumer>
                <FormDataConsumer>
                  {({ formData }) => {
                    if (!process || !process.roles || !coproInternalId) return
                    const { setValue } = useFormContext()

                    return (
                      process.roles.some(
                        (role) => role.show_file_with_context
                      ) &&
                      coproInternalId && (
                        <UpsertFileButton
                          resource="unrestricted/file_with_context"
                          basePath="unrestricted/file_with_context"
                          documentType={
                            FileWithContext.DOCUMENT_TYPE.INTERVENTION
                          }
                          copro_id={coproInternalId}
                          issuedBy={FileWithContext.ISSUED_BY.FRONT_PLUGIN}
                          defaultValue={filesToBind}
                          saveResult={(result) => {
                            if (
                              result.accepted_files &&
                              result.accepted_files.length > 0
                            ) {
                              setFilesToBind(result.accepted_files)
                              formData.filesToBind = result.accepted_files
                              setValue(
                                'file_with_context',
                                result.accepted_files.map((f) => f.toJSON())
                              )
                            }
                          }}
                          show_shared_select={true}
                        />
                      )
                    )
                  }}
                </FormDataConsumer>
              </Box>
            </SimpleForm>
          </Create>
          {/* Temporary disabled, Contact should only be edited in Copromatic. Need to repair this functionnality with the new Backend */}
          {/* {coowner_id && (
            <CoownerEditDialog
              onSuccess={() => {
                setCoownerId(null)
              }}
              id={coowner_id}
            />
          )} */}
        </Grid>
      </Grid>
    </div>
  )
}

export const FrontPluginTickets = (props) => {
  const [context_type, setContextType] = useState('')
  const [conversations, setConversations] = useState([])

  window.setContextType = setContextType
  window.setConversations = setConversations

  return (
    <CreateWrapper
      {...props}
      type={context_type}
      conversations={conversations}
    />
  )
}
const MyDatagridRow = ({
  record,
  id,
  onToggleItem,
  children,
  selected,
  selectable,
}) => {
  const classes = useStyles()
  const isOnMobile = useMediaQuery('(max-width:480px)')
  return (
    <RecordContextProvider value={record}>
      {!isOnMobile ? (
        <TableRow>
          <TableCell padding="none">
            <Checkbox
              style={{
                paddingLeft: '16px',
              }}
              checked={selected}
              onClick={(event) => onToggleItem(id, event)}
            />
          </TableCell>
          {Children.map(children, (field) => (
            <TableCell key={`${id}-${field.props.source}`}>{field}</TableCell>
          ))}
        </TableRow>
      ) : (
        <TableRow>
          <TableCell padding="none" colSpan={4}>
            <Box className={classes.row}>
              <Checkbox
                checked={selected}
                onClick={(event) => onToggleItem(id, event)}
              />
              <Box className={classes.rowInfos}>
                {Children.map(children, (field) => {
                  return (
                    <p key={`${id}-${field.props.source}`}>
                      {field.props.label} : {field}
                    </p>
                  )
                })}
              </Box>
            </Box>
          </TableCell>
        </TableRow>
      )}
    </RecordContextProvider>
  )
}

const MyDatagridBody = (props) => (
  <DatagridBody {...props} row={<MyDatagridRow />} />
)

const DatagridHeader = ({ children, ...props }) => {
  const isOnMobile = useMediaQuery('(max-width:480px)')

  return (
    <>
      {!isOnMobile ? (
        <TableHead>
          <TableRow>
            <TableCell style={{ paddingLeft: 8 }}>
              <Checkbox
                checked={props.selectedIds.length}
                onClick={(event) =>
                  props.onSelect(props.data.map((item) => item.id))
                }
              />
            </TableCell>
            {Children.map(children, (child) => (
              <TableCell key={child.props.source}>
                {child.props.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
      ) : (
        <TableHead>
          <TableRow>
            <TableCell style={{ paddingLeft: 8 }} colSpan={4}>
              <Checkbox
                checked={props.selectedIds.length}
                onClick={(event) =>
                  props.onSelect(props.data.map((item) => item.id))
                }
              />
            </TableCell>
          </TableRow>
        </TableHead>
      )}
    </>
  )
}

const MyDatagrid = (props) => {
  return (
    <Datagrid
      {...props}
      body={<MyDatagridBody />}
      header={<DatagridHeader />}
    />
  )
}

const CreateWrapper = (props) => {
  const [init, setInit] = useState(false)
  const [creating, setCreating] = useState(false)
  const [attaching, setAttaching] = useState(false)
  const [type, setType] = useState(null)
  const [condos, setCondos] = useState([])
  const [selectedSlug, setSelectedSlug] = useState(null)
  const [existingCondoSlugCustomField, setExistingCondoSlugCustomField] =
    useState(null)
  const { conversations } = props
  const refresh = useRefresh()

  useEffect(() => {
    backofficeRequest.get(`backoffice/front/condos`).then((res) => {
      const condosWithSlugs = res.data.filter((copro) => copro.alias)
      setCondos(condosWithSlugs)
    })
  }, [])

  const initFunc = async () => {
    Front.contextUpdates.subscribe(async (context) => {
      window.context['front-teammate-email'] = context.teammate.email.replace(
        /\+.*@/,
        '@'
      )

      const { type } = context

      let conversations = []

      window.context['type'] = type

      if (type === 'singleConversation') conversations = [context.conversation]
      if (type === 'multiConversations') conversations = context.conversations
      if (type === 'noConversation') conversations = []

      if (window.setContextType !== undefined) window.setContextType(type)
      if (window.setConversations !== undefined)
        window.setConversations(conversations)

      if (!conversations?.length) {
        throw new Error('No conversation found')
      }

      const { data: customFields } = await backofficeRequest.get(
        `backoffice/front/conversations/${conversations[0].id}/custom-fields`
      )

      if (customFields && customFields[CONDO_SLUG_CUSTOM_FIELD]) {
        setExistingCondoSlugCustomField(customFields[CONDO_SLUG_CUSTOM_FIELD])
      }

      if (type) {
        setType(type)
        setInit(true)
      }
    })
  }

  const toggleAndRefresh = () => {
    setCreating(false)
    setAttaching(!attaching)
    refresh()
  }
  const toggleCreating = () => {
    setAttaching(false)
    setCreating(!creating)
  }
  const toggleAttaching = () => {
    setCreating(false)
    setAttaching(!attaching)
  }
  useEffect(() => {
    initFunc()
  }, [])

  if (init && type !== 'singleConversation' && type !== 'multiConversations') {
    return null
  }

  const handleAddCondo = async () => {
    if (!selectedSlug || !conversations?.length) {
      return
    }
    const { id, tags } = conversations[0]
    await backofficeRequest.post(
      `backoffice/front/conversations/${id}/add-custom-field`,
      {
        custom_field: {
          name: CONDO_SLUG_CUSTOM_FIELD,
          value: selectedSlug,
        },
        tags,
      }
    )
  }

  return (
    <>
      {!init ? (
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={!init}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <div
          style={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Box fullWidth padding={2}>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '16px',
              }}
            >
              <Typography variant="h5">HelloApp</Typography>

              <Box
                sx={{
                  display: 'flex',
                }}
              >
                <FrontPluginCTA
                  icon={<HomeOutlinedIcon />}
                  title="Voir tous les tickets"
                  onClick={() =>
                    window.open('https://syndic.manda.fr/tickets', '_blank')
                  }
                />
                <FrontPluginCTA
                  icon={<SendOutlinedIcon />}
                  onClick={() =>
                    window.open('https://syndic.manda.fr/massmails', '_blank')
                  }
                  title="Envoyer un mail en masse"
                />
              </Box>
            </Box>
            {existingCondoSlugCustomField ? (
              <MuiAlert severity="info">
                Copro rattachée : {existingCondoSlugCustomField}
              </MuiAlert>
            ) : (
              <MuiAlert severity="warning">
                Nous n’avons pas réussi à identifier la copropriété de cette
                conversation Front. Merci de sélectionner une copropriété
              </MuiAlert>
            )}
            <Autocomplete
              options={condos}
              getOptionLabel={(copro) =>
                `${copro.alias} - ${copro.street}, ${copro.city} - ${copro.copromaticId}`
              }
              fullWidth
              sx={{ backgroundColor: 'white', marginY: '10px' }}
              renderInput={(params) => (
                <MuiTextField {...params} label="Copros" />
              )}
              onChange={(event, selectedCopro) => {
                setSelectedSlug(selectedCopro.alias)
              }}
            />
            <Button
              size="large"
              variant="contained"
              color="primary"
              onClick={handleAddCondo}
              disabled={!selectedSlug}
              fullWidth
            >
              Rattacher la copro à la conversation
            </Button>
            <Button
              size="large"
              variant="contained"
              color="primary"
              onClick={toggleCreating}
              fullWidth
              style={{
                marginTop: '16px',
                marginBottom: '16px',
              }}
            >
              Créer un ticket
            </Button>{' '}
            {creating === true ? (
              <FrontPluginTicketCreate
                {...props}
                conversations={conversations}
              />
            ) : (
              <div />
            )}
            <FrontPluginHome conversation={conversations[0]} />
          </Box>
        </div>
      )}
    </>
  )
}
